import { Validations } from "./validations";

export default class ValidationError extends Error {
  public message: string;

  public source?: Validations;

  public constructor(message: string, source?: Validations) {
    super(message);

    this.message = message;
    this.source = source;
  }
}
